import API from "@/interceptors/Api";
import { getApiErrorStatus } from "@/utils/apiError";
import type { MyCashPoolingRole } from "../types/role.types";

export const getMyRole = async (): Promise<MyCashPoolingRole | null> => {
  try {
    const response = await API.get("/cash-pooling/roles/me");
    return response as unknown as MyCashPoolingRole;
  } catch (error: unknown) {
    const status = getApiErrorStatus(error);
    if (status === 403 || status === 404) {
      return null;
    }
    throw error;
  }
};
